import { ServiceProvider } from '@prisma/client';
import axios from 'axios';

export async function createServiceProvider(
  data: Omit<ServiceProvider, 'id' | 'slug'>,
  ref?: string
) {
  const url = ref ? `/api/service-provider?ref=${ref}` : '/api/service-provider';
  const response = await axios.post(url, data);
  return response.data;
}

export async function updateServiceProvider(
  id: string,
  data: Omit<Partial<ServiceProvider>, 'slug'>
) {
  const response = await axios.patch(`/api/service-provider/${id}`, data);
  return response.data;
}

export async function deleteServiceProvider(id: string) {
  const response = await axios.delete(`/api/service-provider/${id}`);
  return response.data;
}

export async function claimServiceProviderInvite(
  id: string,
  invite_code: string
) {
  const response = await axios.post(`/api/service-provider/${id}/claim`, {
    invite_code,
  });
  return response.data;
}

export async function changeServiceProviderPlan(id: string, plan: string) {
  const response = await axios.patch(`/api/service-provider/${id}`, {
    plan,
  });
  return response.data;
}
